"use client";

import Link from "next/link";
import type { ComponentProps } from "react";

import { resetScrollOnNavigate } from "@/lib/reset-scroll-on-navigate";

/**
 * Drop-in `next/link` for an internal link whose destination renders a
 * hero (see `resetScrollOnNavigate` for why) — for use from a Server
 * Component, which can't pass an `onClick` function as a prop itself.
 */
export function ResetScrollLink({
  onClick,
  ...props
}: ComponentProps<typeof Link>): React.ReactElement {
  return (
    <Link
      {...props}
      scroll={false}
      onClick={(event) => {
        onClick?.(event);
        resetScrollOnNavigate();
      }}
    />
  );
}
